
<app-button
  class="detail-btn"
  (click)="btnClickedHandler()"
  [buttonStyle]="'text'"
  [buttonSize]="'action'"
  ><i *ngIf="isShowIcon" class="far fa-check-circle me-2"></i>{{ params.label }}</app-button
>

<app-button *ngIf="!params.data.isPaid && params.showRetry"
  (click)="retryBtnClickedHandler()"
  [buttonStyle]="'text'"
  [buttonSize]="'action'"
  >Retry</app-button
>

